import React from "react";
import { FaFolder, FaCalendarAlt, FaFingerprint } from "react-icons/fa";

const CategoryView = ({ currentRecord }) => {
  return (
    <div className="w-full max-w-2xl mx-auto overflow-hidden bg-white rounded-lg shadow-lg">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <h2 className="text-2xl font-semibold text-gray-800">
          Category Details
        </h2>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="flex items-center">
            <FaFolder className="mr-3 text-blue-500" size={20} />
            <div>
              <p className="text-sm font-medium text-gray-600">Category Name</p>
              <p className="text-lg font-semibold text-gray-900">
                {currentRecord.category_name}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex items-center justify-center w-10 h-10 mr-3 bg-blue-100 rounded-full">
              <span className="font-semibold text-blue-500">
                {currentRecord.category_type.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">Category Type</p>
              <p className="text-lg font-semibold text-gray-900">
                {currentRecord.category_type}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <FaCalendarAlt className="mr-3 text-green-500" size={20} />
            <div>
              <p className="text-sm font-medium text-gray-600">Created At</p>
              <p className="text-lg font-semibold text-gray-900">
                {new Date(currentRecord.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <FaFingerprint className="mr-3 text-purple-500" size={20} />
            <div>
              <p className="text-sm font-medium text-gray-600">ID</p>
              <p className="text-lg font-semibold text-gray-900">
                {currentRecord.id}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryView;
